import { useCallback, useState } from "react";
import { ButtonsContainer, Content, Button } from "./styled";
import { UpOutlined, DownOutlined } from "@ant-design/icons";

interface CollapseProps {
    children: React.ReactNode;
    height?: number;
    onStateChange?: (open: boolean) => void;
    moreText?: string;
    lessText?: string;
}

export const Collapse: React.FC<CollapseProps> = ({
    children,
    height,
    onStateChange,
    moreText = "Читать больше",
    lessText = "Свернуть"
}) => {
    const [open, setOpen] = useState(false);

    const toggleContainer = useCallback(() => {
        onStateChange && onStateChange(!open);
        setOpen(!open);
    }, [open, onStateChange]);

    return (
        <div className="flex flex-col items-center">
            <Content $open={open} $height={height}>
                {children}
            </Content>
            <div className="w-full flex flex-row justify-center sm:justify-end">
                {!open && <Button size="large" type="link" onClick={toggleContainer}>{moreText}<DownOutlined /></Button>}
                {open && <Button size="large" type="link" onClick={toggleContainer}>{lessText}<UpOutlined /></Button>}
            </div>
        </div>
    );
}